import axios from "axios";
import { ENDPOINT } from "../../constants/endpoint.js";
import _ from "lodash";
const token =
  "eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiIxIiwic2NwIjoidXNlciIsImF1ZCI6bnVsbCwiaWF0IjoxNjAwODM3NTM3LCJleHAiOjI3MjY2ODA3MzY1NTM3LCJqdGkiOiI3Y2E2NzYwNC1lN2UwLTQ0ZWUtYjY1Ny0wM2EzMDkyNWMwMzcifQ.9YLNDUd2DO6qnlnGfyrdzQRGaeFBE2adWcHWaEV-z_0";

const state = {
  loading: false,
  error: {},
  transferData: [],
  overFlowTransfers: []
};

const getters = {};

const actions = {
  // action
  getTransferLogs(context) {
    context.commit("LOADING", { loading: true });

    $.ajax({
      url: `https://mp-new.excise-online.com/transfer_logs.json`,
      type: "GET",
      beforeSend: (xhr) => {
        xhr.setRequestHeader("Authorization", `Bearer ${token}`);
      },
      success: (res) => {
        let transferData = _.map(res, (a) => {
          return {
            id: _.get(a, "id"),
            transfer_report_id: _.get(a, "transfer_report_id"),
            transfer_id: _.get(a, "transfer_id"),
            transfer_date: _.get(a, "transfer_date"),
            tanker_id: _.get(a, "tanker_id"),
            vessel_id: _.get(a, "vessel_id"),
            volume: _.get(a, "volume"),
          };
        });
        context.commit("SUCCESS_TRANSFER_DATA", { transferData });
      },
      error: (e) => {
        context.commit("ERROR_TRANSFER_DATA", { error: e });
      },
      complete: () => {
        // complete
        context.commit("LOADING", { loading: false });
      },
    });
  },
  async getOverFlowTransfer(context, data){
    const url = ENDPOINT.MP_GET_OVER_FLOW_TRANSFER;
    console.log("getOverFlowTransfer >>>>> " ,data);
    const config = {
      params: {
      //   'q[vessel_mmsi_eq]': data.mmsi,
      //   'q[record_time_gteq]': data.selectedDate.start,
      //   'q[record_time_lteq]': data.selectedDate.end,
      //   'q[ais_loss_eq]': data.status ? data.status.id != 0 ? data.status.value : null : null,
        // 'limit': (data.selectedDate.start == null && data.selectedDate.end == null) && 10,
      }
    }

    await axios
      .get(url, config)
      .then((response) => {
        const data  = _.orderBy(response.data, ["transfer.start_at"], ["desc"]);
        context.commit("SET_OVER_FLOW_TRANSFER", data);
      })
      .catch((error) => {
        console.log("Base station Error :", error);
      });
  }, 
};

const mutations = {
  SET_OVER_FLOW_TRANSFER: (state, payload) => {
    state.overFlowTransfers = payload;
  },
  // mutations
  SUCCESS_TRANSFER_DATA(state, payload) {
    state.transferData = payload.transferData;
  },
  ERROR_TRANSFER_DATA(state, payload) {
    state.error = {
      ...payload,
    };
  },
  LOADING_TRANSFER_DATA(state, payload) {
    state.loading = payload.loading;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
